export default __webpack_public_path__ + "static/media/facebook.5aa9dd97.svg";